const wrongSteps = [
  { time: 'Bar N Close', action: 'Signal generated', color: '#ef4444' },
  { time: 'Bar N Close', action: 'Entry filled at Bar N open price', color: '#ef4444' },
  { time: 'Bar N+1', action: 'Already in trade', color: '#ef4444' },
];

const correctSteps = [
  { time: 'Bar N Close', action: 'Signal generated', color: '#22c55e' },
  { time: 'Bar N+1 Open', action: 'Entry filled at next bar open', color: '#22c55e' },
  { time: 'Bar N+1+', action: 'Trade managed from here', color: '#22c55e' },
];

function Timeline({ steps, label, borderColor }: {
  steps: { time: string; action: string; color: string }[];
  label: string;
  borderColor: string;
}) {
  return (
    <div className="mock-compare-panel">
      <div className="mock-compare-title" style={{ color: borderColor }}>
        {label}
      </div>
      <div style={{ position: 'relative', paddingLeft: '1rem' }}>
        {/* Vertical line */}
        <div style={{
          position: 'absolute', left: 3, top: 4, bottom: 4, width: 2,
          background: `${borderColor}30`, borderRadius: 1,
        }} />
        {steps.map((s, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'flex-start', gap: '0.75rem',
            marginBottom: i < steps.length - 1 ? '0.75rem' : 0,
            position: 'relative',
          }}>
            {/* Dot on timeline */}
            <div style={{
              position: 'absolute', left: '-0.85rem', top: '0.2rem',
              width: 8, height: 8, borderRadius: '50%',
              background: s.color, opacity: 0.8,
            }} />
            <div>
              <div style={{
                fontSize: '0.625rem', fontWeight: 700, color: s.color,
                fontFamily: 'ui-monospace, monospace', marginBottom: '0.1rem',
              }}>
                {s.time}
              </div>
              <div style={{ fontSize: '0.6875rem', color: '#d1d5db' }}>
                {s.action}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function LookAheadBiasMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Signal Timing: Wrong vs Correct
      </div>
      <div className="platform-mock-body">
        <div className="mock-compare">
          <Timeline
            steps={wrongSteps}
            label="Look-Ahead Bias (Wrong)"
            borderColor="#ef4444"
          />
          <Timeline
            steps={correctSteps}
            label="Correct Execution (Next-Bar)"
            borderColor="#22c55e"
          />
        </div>
        <div style={{
          marginTop: '0.75rem', padding: '0.5rem 0.75rem',
          background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.15)',
          borderRadius: 6, fontSize: '0.6875rem', color: '#9ca3af',
        }}>
          <span style={{ color: '#ef4444', fontWeight: 600 }}>Key difference: </span>
          The wrong approach fills the trade at a price the strategy could not have known.
          The correct approach waits for the next available bar to execute.
        </div>
      </div>
      <div className="platform-mock-caption">
        A signal on Bar N should only execute on Bar N+1. Anything else is future information.
      </div>
    </div>
  );
}
